module.exports = __webpack_public_path__ + "static/Kvantum_Icon-1b07228e74fc36162c32acfac4efd94a.png";